(function(){
  function inr(n){ return '₹' + Math.round(n).toLocaleString('en-IN'); }
  function initRoot(pdp){
    if(pdp.__odraInit) return; pdp.__odraInit = true;
    var unit = parseFloat(pdp.getAttribute('data-price')) || 0;
    var qty = 1, sub = false;
    function syncCta(){
      var u = sub ? Math.round(unit*0.85) : unit;
      pdp.querySelectorAll('[data-cta-price]').forEach(function(el){ el.textContent = inr(u*qty); });
      var sp = pdp.querySelector('[data-sticky-price]'); if(sp) sp.textContent = inr(u);
    }
    function toggleAcc(item, sel){ if(!item) return; var open = item.classList.toggle('open'); var body = item.querySelector(sel); if(body) body.style.maxHeight = open ? body.scrollHeight+'px' : '0px'; }
    function filterReviews(f){
      pdp.querySelectorAll('[data-revgrid] .rev-card').forEach(function(c){
        var show = true;
        if(f==='photos') show = parseInt(c.getAttribute('data-photos'),10) > 0;
        else if(f!=='all') show = c.getAttribute('data-tag')===f;
        c.style.display = show ? '' : 'none';
      });
    }
    function addToCart(id, q){
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:[{ id: id, quantity: q }] }) })
        .then(function(res){ if(!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function(){ window.location.href = '/cart'; })
        .catch(function(){ window.location.href = '/cart'; });
    }
    pdp.addEventListener('click', function(e){
      var opt = e.target.closest('[data-opt]');
      if(opt){ sub = opt.getAttribute('data-opt')==='sub'; pdp.querySelectorAll('[data-popt] .popt__row').forEach(function(r){ r.classList.toggle('on', r.getAttribute('data-opt')===(sub?'sub':'once')); }); syncCta(); return; }
      var q = e.target.closest('[data-qty]');
      if(q){ qty = Math.max(1, qty + parseInt(q.getAttribute('data-qty'),10)); var qv = pdp.querySelector('[data-qtyval]'); if(qv) qv.textContent = qty; syncCta(); return; }
      var thumb = e.target.closest('[data-gthumb]');
      if(thumb){ var src = thumb.getAttribute('data-src'); var main = pdp.querySelector('[data-gmain]'); if(src && main){ main.src = src; } pdp.querySelectorAll('[data-gthumb]').forEach(function(t){ t.classList.toggle('on', t===thumb); }); return; }
      var sq = e.target.closest('.spec-q'); if(sq){ toggleAcc(sq.closest('.spec-item'), '.spec-body'); return; }
      var fq = e.target.closest('.faq-q'); if(fq){ toggleAcc(fq.closest('.faq-item'), '.faq-body'); return; }
      var rf = e.target.closest('[data-rf]'); if(rf){ filterReviews(rf.getAttribute('data-rf')); pdp.querySelectorAll('[data-revfilters] button').forEach(function(b){ b.classList.toggle('on', b===rf); }); return; }
      var add = e.target.closest('[data-add-id]');
      if(add){ e.preventDefault(); var isCurrent = add.hasAttribute('data-add-current'); addToCart(add.getAttribute('data-add-id'), isCurrent?qty:1); return; }
    });
    syncCta();
    var bar = pdp.querySelector('[data-stickybar]'); var buy = pdp.querySelector('.bb__add');
    if(bar && buy && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){ entries.forEach(function(en){ bar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); }); }, {rootMargin:'0px'}).observe(buy);
    }
  }
  function boot(){ document.querySelectorAll('[data-odra-root]').forEach(initRoot); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
